import { render, staticRenderFns } from "./GrupoPermissoes.vue?vue&type=template&id=782f820c&scoped=true"
import script from "./GrupoPermissoes.vue?vue&type=script&lang=js"
export * from "./GrupoPermissoes.vue?vue&type=script&lang=js"
import style0 from "./GrupoPermissoes.vue?vue&type=style&index=0&id=782f820c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782f820c",
  null
  
)

export default component.exports